import React from 'react';
import { logoutUser } from '../../../../actionCreators/auth';
import { useDispatch } from 'react-redux';
import './Dropdown.scss';
import Membership from '../Membership/Membership';
import DropdownNav from '../DropdownNav/DropdownNav';

function getInitials(name) {
  if (!name) return '';

  const words = name.trim().split(/\s+/);
  let initials = '';

  if (words.length === 1) {
    initials = words[0][0];
  } else {
    initials = words[0][0] + words[words.length - 1][0];
  }

  return initials.toUpperCase();
}

const Dropdown = ({ toggleDropdown, user }) => {
  const dispatch = useDispatch();
  const { firstName, lastName, email } = user;

  const handleLogout = () => {
    dispatch(logoutUser());
  };

  return (
    <div className={`odDropdown ${toggleDropdown && 'open'}`}>
      <div className="odDropdown__profile">
        <div className="odDropdown__pic">{getInitials(`${firstName} ${lastName}`)}</div>
        <div className="odDropdown__nameEmail">
          <div className="odDropdown__name">
            {firstName} {lastName}
          </div>
          <div className="odDropdown__email">{email}</div>
        </div>
      </div>
      <Membership />
      <DropdownNav />
      <div className="odDropdown__logout" onClick={handleLogout}>
        Logout
      </div>
    </div>
  );
};

export default Dropdown;
